/**
 * @typedef ConfigObject
 * @type {object}
 * @property {string} API_BASE_PATH - base url for the backend
 * @property {number} API_TIMEOUT - request timeout in milliseconds
 * @property {string} SC_GOV_URL - base URL for sc.gov links (environment-specific)
 * @property {string} PORTAL_DASHBOARD_URL - external portal dashboard link
 * @property {string} PORTAL_SERVICES_URL - external portal services link
 */

const SC_GOV_STAGING = "https://nicscode355.prod.acquia-sites.com";
const SC_GOV_PROD = "https://sc.gov";

const configMap = {
  local: {
    API_BASE_PATH: "/api",
    API_TIMEOUT: 100000,
    SC_GOV_URL: SC_GOV_STAGING,
    PORTAL_DASHBOARD_URL: "/portal/dashboard",
    PORTAL_SERVICES_URL: "/portal/services",
    PORTAL_DOCUMENTS_URL: "/portal/documents",
    PORTAL_EVENTS_URL: "/portal/events",
    PORTAL_NOTIFICATIONS_URL: "/portal/notifications",
    PORTAL_SETTINGS_URL: "/portal/settings",
    SSO_REDIRECT_PATH: "/",
  },
  dev: {
    API_BASE_PATH: "/api/portal.v1",
    API_TIMEOUT: 10000,
    SC_GOV_URL: SC_GOV_STAGING,
    PORTAL_DASHBOARD_URL: "/portal/dashboard",
    PORTAL_SERVICES_URL: "/portal/view-all-services",
    PORTAL_DOCUMENTS_URL: "/portal/documents",
    PORTAL_EVENTS_URL: "/portal/events",
    PORTAL_NOTIFICATIONS_URL: "/portal/notifications",
    PORTAL_SETTINGS_URL: "/portal/settings",
    SSO_REDIRECT_PATH: "/sso",
  },
  qa: {
    API_BASE_PATH: "/api/portal.v1",
    API_TIMEOUT: 10000,
    SC_GOV_URL: SC_GOV_STAGING,
    PORTAL_DASHBOARD_URL: "/portal/dashboard",
    PORTAL_SERVICES_URL: "/portal/view-all-services",
    PORTAL_DOCUMENTS_URL: "/portal/documents",
    PORTAL_EVENTS_URL: "/portal/events",
    PORTAL_NOTIFICATIONS_URL: "/portal/notifications",
    PORTAL_SETTINGS_URL: "/portal/settings",
    SSO_REDIRECT_PATH: "/sso",
  },
  uat: {
    API_BASE_PATH: "/api/portal.v1",
    API_TIMEOUT: 10000,
    SC_GOV_URL: SC_GOV_STAGING,
    PORTAL_DASHBOARD_URL: `${SC_GOV_STAGING}/dashboard`,
    PORTAL_SERVICES_URL: `${SC_GOV_STAGING}/discover-services`,
    PORTAL_DOCUMENTS_URL: `${SC_GOV_STAGING}/my-documents`,
    PORTAL_EVENTS_URL: `${SC_GOV_STAGING}/my-events`,
    PORTAL_NOTIFICATIONS_URL: `${SC_GOV_STAGING}/my-notifications`,
    PORTAL_SETTINGS_URL: `${SC_GOV_STAGING}/my-settings`,
    SSO_REDIRECT_PATH: "/sso",
  },
  prod: {
    API_BASE_PATH: "/api/portal.v1",
    API_TIMEOUT: 10000,
    SC_GOV_URL: SC_GOV_PROD,
    PORTAL_DASHBOARD_URL: `${SC_GOV_PROD}/dashboard`,
    PORTAL_SERVICES_URL: `${SC_GOV_PROD}/discover-services`,
    PORTAL_DOCUMENTS_URL: `${SC_GOV_PROD}/my-documents`,
    PORTAL_EVENTS_URL: `${SC_GOV_PROD}/my-events`,
    PORTAL_NOTIFICATIONS_URL: `${SC_GOV_PROD}/my-notifications`,
    PORTAL_SETTINGS_URL: `${SC_GOV_PROD}/my-settings`,
    SSO_REDIRECT_PATH: "/sso",
  },
};

/**
 * @type {ConfigObject}
 */
const baseConfig = configMap[import.meta.env.VITE_APP_STAGE] ?? configMap.local;

export const CONFIG = {
  ...baseConfig,
  ...(import.meta.env.VITE_PORTAL_DASHBOARD_URL
    ? { PORTAL_DASHBOARD_URL: import.meta.env.VITE_PORTAL_DASHBOARD_URL }
    : {}),
  ...(import.meta.env.VITE_PORTAL_SERVICES_URL
    ? { PORTAL_SERVICES_URL: import.meta.env.VITE_PORTAL_SERVICES_URL }
    : {}),
};
